import { localId } from 'src/app/helpers/local-id';

export class ItemLog {
  public readonly id = localId();

  public constructor(
    public codeGroup: string,
    public activityCode: string,
    public activityCodeText: string,
    public activityText: string,
    public createdBy: string,
    public createdOn?: Date
  ) {}
}
